import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectLanguage, selectUserInfo } from "../../App/module/selectors";
import { IUserInfo } from "../../models/User";
import { changeLanguage } from "../../App/module/actions";
import { isEmpty } from "ramda";

interface ILanguageProps {
  locale?: any;
  messages: object;
  children?: JSX.Element | JSX.Element[];
  userInfo?: IUserInfo;
  changeLanguage: (lang: string) => void;
}

const langChangeValue = {
  ITA: "it",
  ENG: "en",
};

const LanguageProvider = (props: ILanguageProps): JSX.Element => {
  // eslint-disable-line react/prefer-stateless-function
  const [lang, setLang] = useState<string>("en");
  const { locale, messages, children, userInfo, changeLanguage } = props;

  useEffect(() => {
    setLang(locale);
  }, [locale]);

  useEffect(() => {
    if (userInfo && !isEmpty(userInfo)) {
      changeLanguage(
        langChangeValue[userInfo.language as keyof typeof langChangeValue]
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  return (
    <IntlProvider
      locale={lang}
      key={locale}
      messages={messages[locale as keyof typeof messages]}
    >
      {React.Children.only(children)}
    </IntlProvider>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    locale: selectLanguage,
    userInfo: selectUserInfo,
  });

const mapDispatchToProps: any = {
  changeLanguage: changeLanguage,
};

const withConnet = connect(mapStateToProps, mapDispatchToProps);

export default withConnet(LanguageProvider);
